// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"e8ca85a3","225":"554693d8","263":"781e7cdc","267":"bde18048","371":"902750b5","387":"40a0837e","532":"8528abb6","675":"158b484e","824":"55997635","861":"1a4ba2e5","934":"8afd3e81","961":"750605cc"}[chunkId] + ".js";
};